import { createPopper, Instance } from '@popperjs/core';
import React, { useCallback, useEffect, useRef } from 'react';
import WfButton from './WfButton';

type Target = {
	x: number;
	y: number;
} | null;

interface Props {
	target: Target;
	className?: string;
	itemRow?: any;
	handleCloseMenu?: any;
	actionClick?: any;
	tracker: string;
	objectId: string;
	ButtonProps?: any;
	additionalFunc?: (currStatusId?: string | undefined, codeButton?: string | undefined) => void;
	handleClick?: (props: WfAction) => void;
	additionalProps?: any;
	forceRender?: boolean;
	prefixFunction?: (
		currentStatusCode: string,
		wfCallbackFn: () => void | Promise<any>,
		cancel?: () => void,
		listResponse?: {}
	) => void | Promise<any>;
	getTrackerField?: (fields: any) => void;
	hiddenWfButton?: boolean;
	componentName?: string;
	additionalMenuItems?: any[];
}

interface WfAction {
	componentName: string;
	nameReq: string;
	cancel?: () => void;
	submit: () => void;
}

const WfContextMenu = (props: Props) => {
	const { target, handleCloseMenu, additionalMenuItems } = props;

	const virtualRef = useRef<{ getBoundingClientRect: () => DOMRect } | null>(null);
	const menuRef = useRef<HTMLUListElement>(null);
	const popperInstance = useRef<Instance | null>(null);
	const isExistDisplayComponent = useRef(false);

	useEffect(() => {
		if (target && menuRef.current) {
			virtualRef.current = {
				getBoundingClientRect: () => new DOMRect(target.x, target.y, 0, 0),
			};

			if (popperInstance.current) {
				popperInstance.current.destroy();
			}

			popperInstance.current = createPopper(virtualRef.current as any, menuRef.current, {
				placement: 'auto-end',
				modifiers: [
					{ name: 'offset', options: { offset: [0, 4] } },
					{ name: 'preventOverflow', options: { padding: 8 } },
					{
						name: 'flip',
						options: {
							padding: 8,
							fallbackPlacements: ['top-start', 'right-start', 'left-start'],
						},
					},
				],
			});
		}
	}, [target]);

	useEffect(() => {
		document.addEventListener('click', closeMenu);

		const mutation = new MutationObserver(() => {
			popperInstance.current?.update();
		});

		if (menuRef.current) {
			mutation.observe(menuRef.current, {
				childList: true,
				subtree: false,
			});
		}

		return () => {
			document.removeEventListener('click', closeMenu);
			mutation.disconnect();
		};
	}, []);

	const closeMenu = useCallback(
		(event: MouseEvent) => {
			if (
				target &&
				!isExistDisplayComponent.current &&
				!menuRef.current?.contains(event.target as Node)
			) {
				handleCloseMenu?.();
			}
		},
		[handleCloseMenu, target]
	);

	return (
		<>
			{target && (
				<ul
					ref={menuRef}
					className="spaces p-0 drop-list-container w-200px list-none z-index-20"
				>
					<WfButton
						{...props}
						isContextMenu
						setIsExistDisplayComponent={(isExist: boolean) => {
							isExistDisplayComponent.current = isExist;
						}}
					/>
					{additionalMenuItems?.length
						? additionalMenuItems?.map((item: any, index: number) => {
								return (
									<li
										key={index}
										className={
											'position-relative p-1 d-flex justify-content-between align-items-center border-bottom drop-list-item'
										}
										id="wf-new-status-button"
										onClick={() => item?.onClick?.()}
									>
										<span className="fs-4 min-w-15px text-center">
											<i className={`fs-16 ${item?.icon}`} />
										</span>
										<div className="d-flex justify-content-between align-items-center w-100 ps-2">
											<span>{item?.title}</span>
										</div>
									</li>
								);
						  })
						: ''}
				</ul>
			)}
		</>
	);
};

export default WfContextMenu;
